package com.terapia.terasenior.util

/**
 * Utilidad para el manejo y conversión de fechas en el proyecto Terasenior.
 * Soporta conversión entre formato de usuario (DD-MM-AAAA) y formato de DB (YYYY-MM-DD).
 */
object DateUtils {

    /**
     * Convierte una fecha de formato YYYY-MM-DD (DB) a DD-MM-AAAA (Usuario).
     */
    fun toUserFormat(dbDate: String?): String {
        if (dbDate.isNullOrBlank()) return ""
        val parts = dbDate.split("-")
        if (parts.size != 3) return dbDate
        // Si el formato es YYYY-MM-DD
        if (parts[0].length == 4) {
            return "${parts[2]}-${parts[1]}-${parts[0]}"
        }
        return dbDate
    }

    /**
     * Convierte una fecha de formato DD-MM-AAAA (Usuario) a YYYY-MM-DD (DB).
     */
    fun toDbFormat(userDate: String?): String? {
        if (userDate.isNullOrBlank()) return null
        val normalizedDate = userDate.trim()
        val parts = normalizedDate.split("-").map { it.trim() }
        if (parts.size != 3) return normalizedDate
        // Si el primer segmento tiene 4 dígitos, ya está en formato DB
        if (parts[0].length == 4) return parts.joinToString("-")
        return "${parts[2]}-${parts[1]}-${parts[0]}"
    }
}
